var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Divider, Grid, Typography } from "@mui/material";
import { t } from "i18next";
import { InputBox, MuiStack } from "../../components";
import { MuiSelectComponent } from "../../components/atoms/muiSelectComponent";
import { faintGray } from "../../theme/palette";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { createAPI } from "../../redux/crudSlice";
import { JobcardAlertUpsertUrl } from "../../api/url";
import { showLoader, showNotification } from "../../redux/commonSlice";
import { MuiLoaderButton } from "../../components/atoms/loaderButton";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { GoogleAnlyticsErrorLog } from "../../utils/utils";
var initialFValues = {
    repeatReason: "",
    remarks: ""
};
export var AlertDetailsComponent = function (props) {
    var repeatRevisitReasonList = props.repeatRevisitReasonList, alertId = props.alertId, jobCardId = props.jobCardId, JobcardNo = props.JobcardNo, repeatRevisitId = props.repeatRevisitId, setRemark = props.setRemark, remark = props.remark, setRepeatRevisitId = props.setRepeatRevisitId, EstimatedDateTime = props.EstimatedDateTime;
    var _a = useState(false), isExpand = _a[0], setIsExpand = _a[1];
    var _b = useState(false), isExpandParent = _b[0], setIsExpandParent = _b[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var dispatch = useAppDispatch();
    // useEffect(() => {
    //     if (alertId) {
    //         getAlertDetailsById();
    //         dispatch(getByIdAPI({ key: '', url: RepeatRevisitReasonList }))
    //             .then((result: any) => {
    //                 const list = result && result.payload && result.payload && result.payload.success && result.payload.data ? result.payload.data : [];
    //             });
    //     }
    // }, [alertId])
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        "AlertId": alertId,
                        "ParentId": jobCardId,
                        "ChildAssociations": [],
                        "RepeatRevisitReasonId": repeatRevisitId,
                        "Remarks": remark
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    dispatch(createAPI({
                        key: "",
                        url: JobcardAlertUpsertUrl,
                        request: request
                    })).then(function () {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Alert details updated successfully !",
                            type: "success"
                        }));
                    }).catch(function () {
                        var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Alert details did not updated !");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Alert details did not updated !",
                            type: "error"
                        }));
                    }).finally(function () {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            width: "100%"
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: '#6A7682'
        },
        variant: "h6"
    }, "Estimated date & time:"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, EstimatedDateTime)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Repeat reason*")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "repeatReason",
        options: repeatRevisitReasonList !== null && repeatRevisitReasonList !== void 0 ? repeatRevisitReasonList : [],
        fullWidth: true,
        name: "repeatReason",
        displayExpr: "DisplayName",
        valueExpr: "RepeatRevisitReasonId",
        value: repeatRevisitId,
        onChange: function (event) {
            var id = event.target.value ? event.target.value : "";
            setRepeatRevisitId(id);
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Remarks")), /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 1,
        value: remark,
        onChange: function (event) {
            setRemark(event.target.value);
        },
        placeholder: t('Enter Remarks'),
        fullWidth: true,
        size: "small"
        // value={values?.remarks}
        ,
        name: "remarks"
        // onChange={handleInputChange}
        // error={errors?.remarks}
        ,
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#ffff",
                borderRadius: '8px'
            }
        },
        id: "remarks"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        py: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray)
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        sx: {
            textAlign: 'end'
        }
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        variant: "contained",
        loading: loader.isLoaderOpen,
        size: "medium",
        name: "Save",
        onClick: function () { return handleSave(); }
    })));
};
